var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBubbleOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -646.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,5a1,1,0,0,1-.707-.293l-1-1A1,1,0,0,1,1.707,2.293L2,2.586,4.293.293A1,1,0,0,1,5.707,1.707l-3,3A1,1,0,0,1,2,5",
    transform: "translate(690 653.5)",
    fill: "#091119"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(681 646.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.007,18h0a1,1,0,0,1-1-.889L0,17V3A3,3,0,0,1,3,0H15a3,3,0,0,1,3,3v8a3,3,0,0,1-3,3H5.414L1.707,17.708A.987.987,0,0,1,1.007,18ZM3,2A1,1,0,0,0,2,3V14.584l2.293-2.29a1.006,1.006,0,0,1,.576-.284L5,12H15a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1Z",
    fill: "#091119"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBubbleOk);
export default __webpack_public_path__ + "static/media/icon-bubble-ok.80da654c4927cf22e23f68277f4e35eb.svg";
export { ForwardRef as ReactComponent };